export default __webpack_public_path__ + "static/media/pantry1-afterE-480w.1ddc44ec.png";